import { Box } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { genericMemo } from "../../../utils/utils";
import FormErrorMessage from "../FormErrorMessage";
import { IItem, ISelectIconForm } from "./model";
import SelectIcon from "./SelectIcon";

const SelectIconForm = <T extends IItem>({
  name,
  options,
  label,
  multi,
  addIcon,
}: ISelectIconForm<T>) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={multi ? [] : null}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <Box>
            <SelectIcon
              options={options}
              onChange={onChange}
              multi={multi}
              value={value}
              addIcon={addIcon}
              label={label}
            />
            {error?.message && <FormErrorMessage message={error.message} />}
          </Box>
        );
      }}
    />
  );
};

export default genericMemo(SelectIconForm);
